<template>
	<panel-wrapper :content-class="['panel-invalid', 'is-scrollable']">
		<template slot="name">
			未知面板
		</template>
		<div class="panel-invalid-content">
			<p>面板未找到</p>
			<p> "{{ panel.type }}" 面板类型未找到， 使用编辑模块移除该面板。</p>
		</div>
	</panel-wrapper>
</template>

<script>
import panelMixin from '@/mixins/panel'

export default {
	mixins: [panelMixin]
}
</script>
